import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AppService } from '@core/services/app/app.service';
import { FooterAriaModel, FooterButtonModel } from '@models/ui';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  /**
   * id che identifica il footer
   */
  @Input() id = 'footer';

  /**
   * posizione del footer:
   * fixed-bottom: position fixed a fondo pagina
   * block: display block
   */
  @Input() position: 'fixed-bottom' | 'block' = 'fixed-bottom';

  /**
   * configurazione bottone continua
   */
  @Input() primaryButton: FooterButtonModel;

  /**
   * configurazione aria
   */
  @Input() aria: FooterAriaModel = {};

  /**
   * flag per disabilitate il bottone continua
   */
  @Input() primaryButtonDisabled = false;

  /**
   * configurazione per il bottone secondario
   */
  @Input() secondaryButton: FooterButtonModel;

  /**
   * flag per disabilitare il bottone secondario
   */
  @Input() secondaryButtonDisabled = false;

  /**
   * suggerimento
   */
  @Input() tip: string;

  /**
   * tipo di container in cui è inserito il footer
   */
  @Input() container: 'page' | 'popup' = 'page';

  /**
   * click sul bottone primario
   */
  @Output() primaryClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * click sul bottone secondario
   */
  @Output() secondaryClick: EventEmitter<void> = new EventEmitter<void>();

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.initButtons();
  }

  onPrimaryClick(): void {
    this.primaryClick.next();
  }

  onSecondaryClick(): void {
    this.secondaryClick.next();
  }

  /**
   * inizializza i bottoni
   */
  private initButtons(): void {
    this.initPrimaryButton();
    this.initSecondaryButton();
  }

  /**
   * inizializza il primo bottone
   */
  private initPrimaryButton(): void {
    if (!!this.primaryButton) {
      return;
    }

    this.primaryButton = {
      text: this.appService.getConfig().theme.footerPrimaryText || '',
      icon: 'chevron-forward-outline'
    };
  }

  /**
   * inizializza il secondo bottonw
   */
  private initSecondaryButton(): void {
    if (!!this.secondaryButton) {
      return;
    }

    this.secondaryButton = {
      text: this.appService.getConfig().theme.footerSecondaryText || '',
      icon: 'chevron-back-outline'
    };
  }
}
